@if(isHorizontalLayoutRequested()){
  <app-horizontal></app-horizontal>
}

@if(isSemiboxLayoutRequested()){
  <app-vertical></app-vertical>
}

@if(isTwoColumnLayoutRequested()){
  <app-two-column></app-two-column>
}

@if(isVerticalLayoutRequested()){
  <app-vertical></app-vertical>
}
